import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import { styled } from '@mui/material/styles';

export const GlobalContainerSettings = styled(Box)({
	height: '90vh',
	flexDirection: 'row',
	overflowY: 'scroll',
});

export const HeaderSettings = styled(Box)({
	minHeight: '10vh',
	color: '#f17e22',
	fontSize: '30px',
	fontWeight: 'bold',
	padding: '65px',
});

export const MainSettings = styled(Box)({
	width: '85vw',
});

export const FooterSettings = styled(Box)({
	position: 'fixed',
	height: '10vh',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	alignContent: 'center',
	bottom: 4,
});

export const TextTitle = styled(InputLabel)({
	marginLeft: '20px',
	marginRight: '20px',
	fontSize: '24px',
	color: '#f17e22',
	minHeight: '10vh',
	whiteSpace: 'break-spaces',
	marginBottom: '-16px',
	marginTop: '20px',
	textAlign: 'justify',
});

export const Text = styled(InputLabel)({
	fontSize: '15px',
	textAlign: 'justify',
	whiteSpace: 'break-spaces',
	marginLeft: '20px',
	marginRight: '20px',
});
